/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AccordianContent } from '../models/accordian-content';
import { AccordianContentApiRespModel } from '../models/accordian-content-api-resp-model';
import { apiMasterAccordianContentAddPost } from '../fn/accordian-content/api-master-accordian-content-add-post';
import { ApiMasterAccordianContentAddPost$Params } from '../fn/accordian-content/api-master-accordian-content-add-post';
import { apiMasterAccordianContentDeleteGet } from '../fn/accordian-content/api-master-accordian-content-delete-get';
import { ApiMasterAccordianContentDeleteGet$Params } from '../fn/accordian-content/api-master-accordian-content-delete-get';
import { apiMasterAccordianContentEditPost } from '../fn/accordian-content/api-master-accordian-content-edit-post';
import { ApiMasterAccordianContentEditPost$Params } from '../fn/accordian-content/api-master-accordian-content-edit-post';
import { apiMasterAccordianContentGetActiveGet } from '../fn/accordian-content/api-master-accordian-content-get-active-get';
import { ApiMasterAccordianContentGetActiveGet$Params } from '../fn/accordian-content/api-master-accordian-content-get-active-get';
import { apiMasterAccordianContentGetAllGet } from '../fn/accordian-content/api-master-accordian-content-get-all-get';
import { ApiMasterAccordianContentGetAllGet$Params } from '../fn/accordian-content/api-master-accordian-content-get-all-get';
import { apiMasterAccordianContentGetByCriteriaPost } from '../fn/accordian-content/api-master-accordian-content-get-by-criteria-post';
import { ApiMasterAccordianContentGetByCriteriaPost$Params } from '../fn/accordian-content/api-master-accordian-content-get-by-criteria-post';
import { apiMasterAccordianContentGetByIdGet } from '../fn/accordian-content/api-master-accordian-content-get-by-id-get';
import { ApiMasterAccordianContentGetByIdGet$Params } from '../fn/accordian-content/api-master-accordian-content-get-by-id-get';
import { StringApiRespModel } from '../models/string-api-resp-model';

@Injectable({ providedIn: 'root' })
export class AccordianContentService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiMasterAccordianContentAddPost()` */
  static readonly ApiMasterAccordianContentAddPostPath = '/api/Master/AccordianContent/Add';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterAccordianContentAddPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterAccordianContentAddPost$Response(params?: ApiMasterAccordianContentAddPost$Params, context?: HttpContext): Observable<StrictHttpResponse<AccordianContentApiRespModel>> {
    return apiMasterAccordianContentAddPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterAccordianContentAddPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterAccordianContentAddPost(params?: ApiMasterAccordianContentAddPost$Params, context?: HttpContext): Observable<AccordianContentApiRespModel> {
    return this.apiMasterAccordianContentAddPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<AccordianContentApiRespModel>): AccordianContentApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterAccordianContentEditPost()` */
  static readonly ApiMasterAccordianContentEditPostPath = '/api/Master/AccordianContent/Edit';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterAccordianContentEditPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterAccordianContentEditPost$Response(params?: ApiMasterAccordianContentEditPost$Params, context?: HttpContext): Observable<StrictHttpResponse<AccordianContentApiRespModel>> {
    return apiMasterAccordianContentEditPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterAccordianContentEditPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterAccordianContentEditPost(params?: ApiMasterAccordianContentEditPost$Params, context?: HttpContext): Observable<AccordianContentApiRespModel> {
    return this.apiMasterAccordianContentEditPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<AccordianContentApiRespModel>): AccordianContentApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterAccordianContentDeleteGet()` */
  static readonly ApiMasterAccordianContentDeleteGetPath = '/api/Master/AccordianContent/Delete';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterAccordianContentDeleteGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterAccordianContentDeleteGet$Response(params?: ApiMasterAccordianContentDeleteGet$Params, context?: HttpContext): Observable<StrictHttpResponse<StringApiRespModel>> {
    return apiMasterAccordianContentDeleteGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterAccordianContentDeleteGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterAccordianContentDeleteGet(params?: ApiMasterAccordianContentDeleteGet$Params, context?: HttpContext): Observable<StringApiRespModel> {
    return this.apiMasterAccordianContentDeleteGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringApiRespModel>): StringApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterAccordianContentGetAllGet()` */
  static readonly ApiMasterAccordianContentGetAllGetPath = '/api/Master/AccordianContent/GetAll';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterAccordianContentGetAllGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterAccordianContentGetAllGet$Response(params?: ApiMasterAccordianContentGetAllGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AccordianContent>>> {
    return apiMasterAccordianContentGetAllGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterAccordianContentGetAllGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterAccordianContentGetAllGet(params?: ApiMasterAccordianContentGetAllGet$Params, context?: HttpContext): Observable<Array<AccordianContent>> {
    return this.apiMasterAccordianContentGetAllGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AccordianContent>>): Array<AccordianContent> => r.body)
    );
  }

  /** Path part for operation `apiMasterAccordianContentGetByCriteriaPost()` */
  static readonly ApiMasterAccordianContentGetByCriteriaPostPath = '/api/Master/AccordianContent/GetByCriteria';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterAccordianContentGetByCriteriaPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterAccordianContentGetByCriteriaPost$Response(params?: ApiMasterAccordianContentGetByCriteriaPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AccordianContent>>> {
    return apiMasterAccordianContentGetByCriteriaPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterAccordianContentGetByCriteriaPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterAccordianContentGetByCriteriaPost(params?: ApiMasterAccordianContentGetByCriteriaPost$Params, context?: HttpContext): Observable<Array<AccordianContent>> {
    return this.apiMasterAccordianContentGetByCriteriaPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AccordianContent>>): Array<AccordianContent> => r.body)
    );
  }

  /** Path part for operation `apiMasterAccordianContentGetByIdGet()` */
  static readonly ApiMasterAccordianContentGetByIdGetPath = '/api/Master/AccordianContent/GetById';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterAccordianContentGetByIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterAccordianContentGetByIdGet$Response(params?: ApiMasterAccordianContentGetByIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<AccordianContent>> {
    return apiMasterAccordianContentGetByIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterAccordianContentGetByIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterAccordianContentGetByIdGet(params?: ApiMasterAccordianContentGetByIdGet$Params, context?: HttpContext): Observable<AccordianContent> {
    return this.apiMasterAccordianContentGetByIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<AccordianContent>): AccordianContent => r.body)
    );
  }

  /** Path part for operation `apiMasterAccordianContentGetActiveGet()` */
  static readonly ApiMasterAccordianContentGetActiveGetPath = '/api/Master/AccordianContent/GetActive';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterAccordianContentGetActiveGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterAccordianContentGetActiveGet$Response(params?: ApiMasterAccordianContentGetActiveGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AccordianContent>>> {
    return apiMasterAccordianContentGetActiveGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterAccordianContentGetActiveGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterAccordianContentGetActiveGet(params?: ApiMasterAccordianContentGetActiveGet$Params, context?: HttpContext): Observable<Array<AccordianContent>> {
    return this.apiMasterAccordianContentGetActiveGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AccordianContent>>): Array<AccordianContent> => r.body)
    );
  }

}
